module.exports = __webpack_public_path__ + "static/media/Me_1.1cec5325.jpeg";